import lookupUserInfo from "infrastructure/user/lookup-user-info";
import signOut from "infrastructure/user/sign-out.service";
import eventBus from "infrastructure/common/eventBus";
import AppRouters from "application/globals/app-routers";
import AuthService from "infrastructure/common/auth";
import {toastHelper} from "presentation/common/helpers/toast";
import StorageService from "infrastructure/common/storage";
import {AppSettings} from "application/index";

export async function onInvalidateUserAction(dispatch) {
  AuthService.invalidAuthenticationToken();
  dispatch.auth.updateAuthStateAction({
    isAuthenticated: false,
    user: null,
  });

  eventBus.dispatch('NAVIGATE', {path: AppRouters.home});
}

export async function onSignOutAction(dispatch) {
  try {
    await signOut();
    StorageService.removeItem(AppSettings.ticketName);
  } catch (e) {

  } finally {
    await onInvalidateUserAction(dispatch);
    eventBus.dispatch('NAVIGATE', {path: AppRouters.home});
  }
}

export async function onLookupUserInfoAction(dispatch) {
  const user = await lookupUserInfo();

  if (user) {
    return dispatch.auth.updateAuthStateAction({
      isAuthenticated: true,
      user,
    })
  }

  toastHelper.error('No pudimos autenticarte. Ocurrió un error al verificar el ticket de autenticación.');
  await onInvalidateUserAction(dispatch);
}
